/* tslint:disable:rule1 max-line-length */

import classnames from 'classnames';
import * as React from 'react';

export const Duplicate = ({ disabled, onClick }) => (
  <svg
    onClick={onClick}
    className={classnames({ 'copy-menu-disabled': disabled })}
    role='button'
    width='73'
    height='70'
    viewBox='0 0 73 70'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <title>background</title>
      <rect fill='none' id='canvas_background' height='72' width='75' y='-1' x='-1' />
    </g>
    <g>
      <title>Layer 1</title>
      <g id='svg_1'>
        <g id='svg_2'>
          <path
            fill='#31358f'
            id='svg_3'
            d='m22.067244,67.97831l43.50001,0c2.400002,0 4.300003,-1.900002 4.300003,-4.300003l0,-43.400003c0,-2.399998 -1.900002,-4.299995 -4.300003,-4.299995l-11.400002,0l0,-8.5c0,-2.799999 -2.299995,-5.099998 -5.099998,-5.099998l-41.800013,0c-2.799998,0 -5.099997,2.299999 -5.099997,5.099998l0,41.799997c0,2.800003 2.299999,5.099998 5.099997,5.099998l10.5,0l0,9.300003c0,2.400002 1.900005,4.300003 4.300003,4.300003zm45.700014,-47.700006l0,43.500002c0,1.300003 -1,2.300003 -2.300003,2.300003l-43.400011,0c-1.299999,0 -2.299999,-1 -2.299999,-2.300003l0,-43.500002c0,-1.299999 1,-2.299999 2.299999,-2.299999l43.50001,0c1.200005,0 2.200005,1 2.200005,2.299999zm-60.500017,32.1c-1.699996,0 -3.099998,-1.399994 -3.099998,-3.099998l0,-41.799997c0,-1.699999 1.400002,-3.099998 3.099998,-3.099998l41.800013,0c1.700005,0 3.099998,1.4 3.099998,3.099998l0,8.5l-30.100008,0c-2.399998,0 -4.300003,1.899998 -4.300003,4.299995l0,32.1l-10.5,0z'
          />
        </g>
      </g>
    </g>
  </svg>
);
